export default __webpack_public_path__ + "static/media/planet.07fa9747.svg";